import { Pagination } from '@refinedev/core';

export const generatePagination = (pagination: Pagination) => ({
  limit: pagination.pageSize || 10,
  offset: (pagination.pageSize || 1) * ((pagination.current || 1) - 1),
  page: pagination.current || 1,
});

export default generatePagination;
